export enum ProdOperatorsEnum {
	CoreparkTest     = 1,   // 7cada1ef-dcac-4616-812b-8c952c297304
	SafecoParking    = 212, // 07cdb2b0-dfc4-43c6-8137-a4df630d02d9
	EvolutionParking = 314, // 0316b264-2ce5-447c-8419-26afbbd2c707
}
